import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { ContentProvider } from "@/context/ContentContext";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import JourneyHome from "@/pages/JourneyHome";
import SectionPage from "@/pages/SectionPage";
import MorePage from "@/pages/MorePage";
import SosPage from "@/pages/SosPage";
import AdminApp from "@/pages/admin/AdminApp";
import { TripGate } from "@/components/TripGate";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <ContentProvider>
                <TripGate>
                  <JourneyHome />
                </TripGate>
              </ContentProvider>
            }
          />
          <Route
            path="/section/:id"
            element={
              <ContentProvider>
                <TripGate>
                  <SectionPage />
                </TripGate>
              </ContentProvider>
            }
          />
          <Route
            path="/more"
            element={
              <ContentProvider>
                <TripGate>
                  <MorePage />
                </TripGate>
              </ContentProvider>
            }
          />
          <Route
            path="/sos"
            element={
              <ContentProvider>
                <TripGate>
                  <SosPage />
                </TripGate>
              </ContentProvider>
            }
          />
          <Route
            path="/admin"
            element={
              <AuthProvider>
                <AdminApp />
              </AuthProvider>
            }
          />
          <Route
            path="*"
            element={
              <ContentProvider>
                <TripGate>
                  <Navigate to="/" replace />
                </TripGate>
              </ContentProvider>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </LanguageProvider>
  );
}

export default App;
